<script setup lang="ts">
import defaultLogoImage from "@/assets/images/logos/logo-icon-pos.png";
</script>
<template>
  <v-card elevation="10" class="overflow-hidden" height="170">
    <VRow class="d-flex justify-center align-center pa-4">
      <VCol cols="12">
        <v-img :src="defaultLogoImage" max-height="135" />
      </VCol>
    </VRow>
  </v-card>
</template>
